const data_CN = {
  topPage: {
    rightImg:require("@/assets/productServices/anchorOperation/pic_kol.png"),
    englishName:'KOL OPERATION',
    name:'主播运营',
    introText:'专注于国内&国际商务领域，帮助品牌在日本和全球市场拓宽知名度和提升销量，与保持长期合作关系。',
    serviceInclude:'服务内容涵盖:',
    bottomImg: true,
    frontIntroText:'OFFSHORE',
    endIntroText:'品牌战略咨询、市场调研和分析、品牌定位与运营、市场进入策略、管理创新、渠道伙伴引入。'
  },
  skillsTainingInfo: {
    title:'技能培养',
    subTitle:'培训&培养体系',
    list: [
      {
        titleEn: 'Mentor Consultant',
        title: '主播导师',
        content: '从0到1到10000 \n协助您极速成长的专业导师',
        bgImage: require("@/assets/productServices/brandOperation/serviceContent/number_01@2x.png"),
        mainImage: require("@/assets/productServices/anchorOperation/skillsTaining/pic_coop01@2x.png")
      },
      {
        titleEn: 'Buddy Crew',
        title: '创意团队',
        content: '全球部署的极速响应团队，快速分析热点，打造爆款',
        bgImage: require("@/assets/productServices/brandOperation/serviceContent/number_02@2x.png"),
        mainImage: require("@/assets/productServices/anchorOperation/skillsTaining/pic_coop02@2x.png")
      }
    ]
  },
  shortVideoInfo: {
    title: '专业团队协助打造“爆款”短视频',
    list: [
      {
        name: '定性&定量-调研市场热点',
        img: require("@/assets/productServices/anchorOperation/shortVideo/pic_2_1@2x.png")
      },
      {
        name: '数据&受众-视频主频道分析',
        img: require("@/assets/productServices/anchorOperation/shortVideo/pic_2_2@2x.png")
      },
      {
        name: '创意&文案-“黄金3秒”极速获粉',
        img: require("@/assets/productServices/anchorOperation/shortVideo/pic_2_3@2x.png")
      },
      {
        name: '美术&视觉-全球部署的领先团队',
        img: require("@/assets/productServices/anchorOperation/shortVideo/pic_2_4@2x.png")
      }
    ]
  },
  channelPlanningInfo: {
    title: '渠道策划',
    bgImage: require("@/assets/productServices/anchorOperation/channelPlanning/bg_circle@2x.png"),
    all_bg_image: require("@/assets/productServices/anchorOperation/channelPlanning/all_bg_circle@2x.png"),
    list:
    [
      {
        image: require("@/assets/productServices/anchorOperation/channelPlanning/circle_item0@2x.png"),
        title: '更多的商业曝光机会'
      },
      {
        image: require("@/assets/productServices/anchorOperation/channelPlanning/circle_item1@2x.png"),
        title: '更贴合视频主人设的品牌合作'
      },
      {
        image: require("@/assets/productServices/anchorOperation/channelPlanning/circle_item2@2x.png"),
        title: '更快的变现手段与稳定的商业合作关系'
      }
    ],
    info: '多渠道整合能力，拉通B端企业与C端成员主播的多元合作',
    image: require("@/assets/productServices/anchorOperation/channelPlanning/pic_coop01.png")
  },
  peripheralProductsInfo: {
    title: '周边产品运营能力',
    list: [
      {
        name: '设计',
        info: ['专业工业与品牌设计团队', '热点追踪分析与多元设计理念', '更贴合视频主个人理念的产品设计'],
        img: require("@/assets/productServices/anchorOperation/peripheralProducts/pic_3_1@2x.png")
      },
      {
        name: '生产',
        info: ['全球合作商体系，快速响应开发生产', '高质量商品交付，确保产品理念输出'],
        img: require("@/assets/productServices/anchorOperation/peripheralProducts/pic_3_2@2x.png")
      },
      {
        name: '运输运营',
        info: ['合作全球物流体系', '全球运营客服网络'],
        img: require("@/assets/productServices/anchorOperation/peripheralProducts/pic_3_3@2x.png")
      }
    ]
  }
}
const data_JA = {
  topPage: {
    rightImg:require("@/assets/productServices/anchorOperation/pic_kol.png"),
    englishName:'KOL OPERATION',
    name:'アンカー操作',
    introText:'国内外のビジネスフィールドに焦点を当て、ブランドが日本および世界市場で人気を拡大し、売上を増加させ、ブランドとの長期的な協力関係を維持するのを支援します。',
    serviceInclude:'サービス内容は:',
    bottomImg: true,
    frontIntroText:'オフショアは',
    endIntroText:'ブランド戦略コンサルティング、市場調査・分析、ブランドポジショニングと運営、市場参入戦略、経営革新、チャネルパートナー紹介など。'
  },
  skillsTainingInfo: {
    title:'能力開発',
    subTitle:'育成システム',
    list: [
      {
        titleEn: 'Mentor Consultant',
        title: 'アナウンサー指導者',
        content: '0から1から10000まで\n急成長をサポートする専門的な指導者',
        bgImage: require("@/assets/productServices/brandOperation/serviceContent/number_01@2x.png"),
        mainImage: require("@/assets/productServices/anchorOperation/skillsTaining/pic_coop01@2x.png")
      },
      {
        titleEn: 'Buddy Crew',
        title: 'アナウンサー指導者',
        content: '世界展開のスピーディなリアクションチーム。ホットなトピックを素早く分析し、ヒット商品を生み出す',
        bgImage: require("@/assets/productServices/brandOperation/serviceContent/number_02@2x.png"),
        mainImage: require("@/assets/productServices/anchorOperation/skillsTaining/pic_coop02@2x.png")
      }
    ]
  },
  shortVideoInfo: {
    title: '爆発的な短いビデオを作るための専門チームのサポート',
    list: [
      {
        name: '定性・定量 - マーケットのホットトピック調査',
        img: require("@/assets/productServices/anchorOperation/shortVideo/pic_2_1@2x.png")
      },
      {
        name: 'データと視聴者 - 動画のメイン チャネル分析',
        img: require("@/assets/productServices/anchorOperation/shortVideo/pic_2_2@2x.png")
      },
      {
        name: 'クリエイティビティとコピーライティング - 「ゴールデン 3 秒」は急速にファンを獲得',
        img: require("@/assets/productServices/anchorOperation/shortVideo/pic_2_3@2x.png")
      },
      {
        name: 'Art & Vision - グローバル展開をリードするチーム',
        img: require("@/assets/productServices/anchorOperation/shortVideo/pic_2_4@2x.png")
      }
    ]
  },
  channelPlanningInfo: {
    title: 'チャネルプランニング',
    bgImage: require("@/assets/productServices/anchorOperation/channelPlanning/bg_circle@2x.png"),
    all_bg_image: require("@/assets/productServices/anchorOperation/channelPlanning/all_bg_circle@2x.png"),
    list:
    [
      {
        image: require("@/assets/productServices/anchorOperation/channelPlanning/circle_item0@2x.png"),
        title: 'ビジネス露出の機会が増える'
      },
      {
        image: require("@/assets/productServices/anchorOperation/channelPlanning/circle_item1@2x.png"),
        title: 'ビデオホストにより適したブランド連携'
      },
      {
        image: require("@/assets/productServices/anchorOperation/channelPlanning/circle_item2@2x.png"),
        title: 'より迅速な実現手段と安定したビジネスパートナーシップ'
      }
    ],
    info: 'マルチチャネル統合能力、B エンド企業と C エンドメンバーアンカー間の複数の協力を実現',
    image: require("@/assets/productServices/anchorOperation/channelPlanning/pic_coop01.png")
  },
  peripheralProductsInfo: {
    title: '周辺製品の操作能力',
    list: [
      {
        name: 'デザイン',
        info: ['プロの産業およびブランドデザインチーム', 'ホットスポット追跡分析と複数の設計コンセプト', 'ビデオ所有者の個人的な哲学により沿った製品デザイン'],
        img: require("@/assets/productServices/anchorOperation/peripheralProducts/pic_3_1@2x.png")
      },
      {
        name: '製造',
        info: ['グローバルパートナー体制、迅速な開発・生産対応', '製品コンセプトの成果を保証するための高品質な商品配送'],
        img: require("@/assets/productServices/anchorOperation/peripheralProducts/pic_3_2@2x.png")
      },
      {
        name: '輸送業務',
        info: ['グローバル連携物流システム', 'グローバルに展開するカスタマーサービスネットワーク'],
        img: require("@/assets/productServices/anchorOperation/peripheralProducts/pic_3_3@2x.png")
      }
    ]
  }
}
 
const data_EN = {
  topPage: {
    rightImg:require("@/assets/productServices/anchorOperation/pic_kol.png"),
    englishName:'KOL OPERATION',
    name:'Anchor Operation',
    introText:'Thanks to our globally distributed operations team, OFFSHORE is dedicated to creating your unique online persona and expanding your influence to generate revenue.',
    serviceInclude:'',
    bottomImg: true,
    frontIntroText:'',
    endIntroText:'Our services include skill development, channel planning, and peripheral product operation capabilities.'
  },
  skillsTainingInfo: {
    title:'Skill training',
    subTitle:'Raining and Development System',
    list: [
      {
        titleEn: 'Mentor Consultant',
        title: 'Announcer Instructor',
        content: 'Professional instructor who helps you grow from zero to one to ten thousand rapidly',
        bgImage: require("@/assets/productServices/brandOperation/serviceContent/number_01@2x.png"),
        mainImage: require("@/assets/productServices/anchorOperation/skillsTaining/pic_coop01@2x.png")
      },
      {
        titleEn: 'Buddy Crew',
        title: 'Creative Team',
        content: 'Globally deployed rapid response team that quickly analyzes hot topics to create explosive hits.',
        bgImage: require("@/assets/productServices/brandOperation/serviceContent/number_02@2x.png"),
        mainImage: require("@/assets/productServices/anchorOperation/skillsTaining/pic_coop02@2x.png")
      }
    ]
  },
  shortVideoInfo: {
    title: 'Professional team assists in creating explosive short videos.',
    list: [
      {
        name: 'Qualitative & Quantitative - Research Market Hotspots',
        img: require("@/assets/productServices/anchorOperation/shortVideo/pic_2_1@2x.png")
      },
      {
        name: 'Data & Audience - Video Main Channel Analysis',
        img: require("@/assets/productServices/anchorOperation/shortVideo/pic_2_2@2x.png")
      },
      {
        name: 'Creativity & Copywriting - "Golden 3 Seconds" Gains Fans Quickly',
        img: require("@/assets/productServices/anchorOperation/shortVideo/pic_2_3@2x.png")
      },
      {
        name: 'Art & Vision - Leading Team for Global Deployment',
        img: require("@/assets/productServices/anchorOperation/shortVideo/pic_2_4@2x.png")
      }
    ]
  },
  channelPlanningInfo: {
    title: 'Channel Planning',
    bgImage: require("@/assets/productServices/anchorOperation/channelPlanning/bg_circle@2x.png"),
    all_bg_image: require("@/assets/productServices/anchorOperation/channelPlanning/all_bg_circle@2x.png"),
    list:
    [
      {
        image: require("@/assets/productServices/anchorOperation/channelPlanning/circle_item0@2x.png"),
        title: 'More business exposure opportunities'
      },
      {
        image: require("@/assets/productServices/anchorOperation/channelPlanning/circle_item1@2x.png"),
        title: 'Brand cooperation that is more suitable for the video host'
      },
      {
        image: require("@/assets/productServices/anchorOperation/channelPlanning/circle_item2@2x.png"),
        title: 'Faster means of realization and stable business partnership'
      }
    ],
    info: 'Multi-channel integration ability, pull through multiple cooperation between B-end enterprises and C-end member anchors',
    image: require("@/assets/productServices/anchorOperation/channelPlanning/pic_coop01.png")
  },
  peripheralProductsInfo: {
    title: 'Peripheral Product Operation Capability',
    list: [
      {
        name: 'Design',
        info: ['Professional industrial and brand design team', 'Hot spot tracking analysis and multiple design concepts', 'Product design that is more in line with the personal philosophy of the video owner'],
        img: require("@/assets/productServices/anchorOperation/peripheralProducts/pic_3_1@2x.png")
      },
      {
        name: 'Produce',
        info: ['Global partner system, rapid response development and production', 'High-quality commodity delivery to ensure product concept output'],
        img: require("@/assets/productServices/anchorOperation/peripheralProducts/pic_3_2@2x.png")
      },
      {
        name: 'Transportation Operations',
        info: ['Cooperative global logistics system', 'Global operation customer service network'],
        img: require("@/assets/productServices/anchorOperation/peripheralProducts/pic_3_3@2x.png")
      }
    ]
  }
}

export default {
  data_CN,
  data_JA,
  data_EN
}


// WEBPACK FOOTER //
// ./src/common/json/anchorOperation.js